<script lang="ts">

    export let src: string;
    export let volume = 0.5;

    let audio: HTMLAudioElement;
    let playRequest = false;

    $: if (audio) audio.volume = volume;

    export function play(): void {
        _play();
        playRequest = true;
    }

    export function pause(): void {
        _pause();
        playRequest = false;
    }

    export function stop(): void {
        _stop();
        playRequest = false;
    }

    async function _play(): Promise<void> {
        if (!audio || !window.document.hasFocus()) {
            return;
        }
        try {
            await audio.play();
        } catch (error) {
            if ('NotAllowedError' === error.name) {
                return;
            }
            console.error(error);
        }
    }

    function _pause(): void {
        if (!audio) {
            return;
        }
        audio.pause();
    }

    function _stop(): void {
        if (!audio) {
            return;
        }
        audio.pause();
        audio.currentTime = 0;
    }

    function onWindowFocus(): void {
        if (playRequest) {
            _play();
        }
    }

    function onWindowBlur(): void {
        _pause();
    }

    function onInteraction(): void {
        if (playRequest) {
            _play();
        }
    }

</script>

<svelte:window
    on:focus={onWindowFocus}
    on:blur={onWindowBlur}
    on:mousedown={onInteraction}
    on:touchstart={onInteraction}
    on:keydown={onInteraction} />

<audio bind:this={audio} {src} preload="auto" loop />
